import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, Table, TableBody, TableItem, TableRow} from 'spectacle';
import {Slide} from '../components/slide';
import {Month} from '../support/import_csv';
import {formatEuro} from '../../support/format_money';
import {isAfter, isBefore, subMonths} from 'date-fns';
import {Footnote} from '../components/footnote';
import {ResultPercentage} from '../components/result_percentage';

interface OwnProps {
    referenceDate: Date;
    months: Month[];
}

export const Buffer: FunctionComponent<OwnProps> = ({months, referenceDate}) => {
    const numberOfReferenceMonths = 6;
    const fromDate = subMonths(referenceDate, numberOfReferenceMonths);
    const monthsThisYear = months.filter(
        (month) => isAfter(month.date, fromDate) && isBefore(month.date, referenceDate),
    );
    const costs = monthsThisYear.reduce((sum, month) => sum + month.cost, 0);
    const averageCostPerMonth = costs / numberOfReferenceMonths;

    const bufferDefinition = {
        liquidity: 189_582.39,
        to_receive: 163_654.19,
        to_pay: 45_958.0,
    };

    return (
        <Slide>
            <Heading size={1} textAlign="left" textColor="secondary">
                Buffer*
            </Heading>
            <Heading size={3} textAlign="left" textColor="tertiary">
                Current state of our bank account
            </Heading>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableItem>Liquidity</TableItem>
                        <TableItem>
                            {formatEuro(bufferDefinition.liquidity)}
                            <ResultPercentage factor={bufferDefinition.liquidity / (2 * averageCostPerMonth)} />
                        </TableItem>
                    </TableRow>
                    <TableRow>
                        <TableItem>Outstanding invoices</TableItem>
                        <TableItem>
                            {formatEuro(bufferDefinition.to_receive)}
                            <ResultPercentage factor={bufferDefinition.to_receive / (2 * averageCostPerMonth)} />
                        </TableItem>
                    </TableRow>
                    <TableRow>
                        <TableItem>Still to pay</TableItem>
                        <TableItem>{formatEuro(-1 * bufferDefinition.to_pay)}</TableItem>
                    </TableRow>
                    <TableRow>
                        <TableItem>Working capital</TableItem>
                        <TableItem>
                            {formatEuro(
                                bufferDefinition.liquidity + bufferDefinition.to_receive - bufferDefinition.to_pay,
                            )}
                        </TableItem>
                    </TableRow>
                </TableBody>
            </Table>
            <Footnote>
                *2 months liquidity + 2 months outstanding; average cost per month based on last{' '}
                {numberOfReferenceMonths}: {formatEuro(averageCostPerMonth)}
            </Footnote>
        </Slide>
    );
};
